<template>
  <router-link :to="`/s-app/item-details/${request.itemId}`">
    <div class="dropdown-item" @click="$emit('button')">
      <div class="container-request-item">
        <md-avatar class="item-image">
          <img
            class="header-img"
            :src="getItemImagePath(data.item)"
            alt="Avatar"
          />
        </md-avatar>
        <div class="action-content">
          <span class="item-name">{{ getItemTitle(data.item) }}</span>
          <span class="action">{{ notificationText }}</span>
          <span class="request-date">{{ data.createdAt | date }}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import itemType from "@/enum/item-type";

export default {
  name: "RequestListDropdown",
  props: ["request"],
  mixins: [GroupHelperVue, UserHelperVue, ItemHelperVue],
  data() {
    return {
      data: this.request,
    };
  },
  computed: {
    notificationText() {
      let requestType = "requesting";
      if (
        this.request.item.type === itemType.RECEIVE ||
        this.request.item.type === itemType.BORROW
      ) {
        requestType = "offering";
      }
      let shipStatus = "receive";
      if (this.request.item.posterId === this.loggedUser.id) {
        if (
          this.request.item.type === itemType.GIVE ||
          this.request.item.type === itemType.LEND
        ) {
          shipStatus = "send";
        }
      } else {
        if (
          this.request.item.type === itemType.RECEIVE ||
          this.request.item.type === itemType.BORROW
        ) {
          shipStatus = "send";
        }
      }
      if (this.request.notification === "new-request") {
        return `${
          this.request.sUser.firstName
        } is ${requestType} the item ${this.getItemTitle(this.request.item)}`;
      } else if (this.request.notification === "accepted") {
        return `Your ${requestType} has been accepted for the item ${this.getItemTitle(
          this.request.item
        )}`;
      } else if (this.request.notification === "pending") {
        return `Did you ${shipStatus} the item ${this.getItemTitle(
          this.request.item
        )}?`;
      } else if (this.request.notification === "rejected") {
        return `Your ${requestType} has been rejected for the item ${this.getItemTitle(
          this.request.item
        )}`;
      } else {
        return "No activities found";
      }
    },
  },
  methods: {
    getActivityLink() {
      if (this.request.notification === "new-request") {
        return "/s-app/item-activity?filter=incoming";
      } else return "/s-app/item-activity";
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  margin-top: 0.4em;
  height: 70px !important;
}
.item-image {
  width: 10%;
  margin: 0 !important;
}
.item-name {
  margin-left: 0.3rem !important;
  text-align: initial !important;
  font-weight: bold;
}
.action,
.item-name {
  text-align: inherit !important;
  margin-left: 0.4em !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 180px;
  color: rgba(0, 0, 0, 0.6);
}
.request-date {
  float: right;
  font-size: 11px !important;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.4);
  text-align: end !important;
}
</style>
